import React from "react";
import css from "./CarNumber.module.css";
import flagUkraine from "./../../assets/img/Flag_of_Ukraine.svg"
const CarNumber = ({ flag, number, ...props }) => {
  const formatCarNumber = (carNumber) => { 
    return carNumber.split("/").map(num=><div key={num}>{num}</div>)
   }
  return (
    number && (
      <div className={css.carNumber} {...props}>
          <div className={css.leftSide}>
              <div className={css.flag}>
                <img src={flagUkraine} alt="ua"/>
              </div>
              <div className={css.code}>ua</div>
          </div>
          <div className={css.rightSide}>{formatCarNumber(number)}</div>
      </div>
    )
  );
};

export default CarNumber;
